import { render, staticRenderFns } from "./NotSafeForWork4.vue?vue&type=template&id=94a5be76&scoped=true&"
import script from "./NotSafeForWork4.vue?vue&type=script&lang=js&"
export * from "./NotSafeForWork4.vue?vue&type=script&lang=js&"
import style0 from "./NotSafeForWork4.vue?vue&type=style&index=0&id=94a5be76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a5be76",
  null
  
)

export default component.exports